// Hooks / Node modules / Styles

// Reducers / Actions

// Utils / Functions

// Components
import DefaultLayout from "src/layout/standard/primary/DefaultLayout";
import TitleBar from "src/components/base/title-bar/TitleBar";

// Sub-Components
import LifestyleCardGroup from "./com/LifestyleCardGroup";

// Data / Images / Icons

function P_Lifestyle() {
  return (
    <DefaultLayout>
      <TitleBar />

      <LifestyleCardGroup />
    </DefaultLayout>
  );
}

export default P_Lifestyle;